var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C10.9659 0 10.125 0.897 10.125 2.00002V4.00003L10.1252 4.01482C7.2711 4.84072 5.17532 7.50317 5.17532 10.65V13.1212C5.17532 14.6402 4.76679 16.1306 3.99463 17.4327L2.31963 20.2538C2.22896 20.4056 2.227 20.5958 2.31282 20.7496C2.39961 20.9044 2.5624 21 2.73789 21H9.85485C9.78566 21.2117 9.75 21.4326 9.75 21.6559C9.75005 22.9489 10.9266 24 12.374 24C13.8213 24 14.9979 22.9489 15 21.6559C15 21.4326 14.9643 21.2117 14.8952 21H21.2621C21.4376 21 21.6004 20.9044 21.6872 20.7496C21.773 20.5958 21.7711 20.4056 21.6804 20.2538L20.0054 17.4327C19.2332 16.1306 18.8247 14.6402 18.8247 13.1212V10.65C18.8247 7.50316 16.7289 4.8407 13.8748 4.01482L13.875 3.99998V2.00002C13.875 0.897 13.0341 0 12 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.86bd4f053c04e6584e81e10ec600b0b4.svg";
export { ForwardRef as ReactComponent };